import "./style.css";
function Loader() {
  return (
    <div className="loader">
      <img
        src="https://acegif.com/wp-content/uploads/loading-80.gif"
        alt="loader"
      />
    </div>
  );
}

export default Loader;
